import { createSlice} from '@reduxjs/toolkit';

export const homesuccesscaseSlice = createSlice({
    name: 'homesuccesscase',
    initialState:{
        openModal:false,
        imgEl:{src:"",alt:"",width:"",height:""}
    },
    reducers: {
        openImgModal(state,action) {
            state.openModal = action.payload;
        },
        setModalImg(state,action){
            state.imgEl = action.payload;
        }
    },
});
export const {openImgModal,setModalImg } = homesuccesscaseSlice.actions;
  
 // reducer
export default homesuccesscaseSlice.reducer;